<template>
    <div class="landing">
        <NavEnvLanding
            v-bind:curentEnvironment="curentEnvironment"
            v-bind:activeEnv="activeEnv"

            v-bind:displayType="displayType"

            v-on:setActiveEnv="changeActiveEnv"

            v-bind:typeSol="typeSol"
            v-bind:switchDisable="switchDisable"


            v-if="showMenuInLanding"

        />
        <div v-show="!preloadPage">

            <video preload="auto" ref="flyPreview" class="media-section video fly-preview"
                   v-bind:class="{ hidden:!flyPreviewActive }"
                   v-show="flyPreviewActive"
                   autoplay muted
                   v-on:ended="videoCompleted('start')"
                   :poster="subdir+'/images/videos/fly-preview.jpg'">
                <source :src="subdir+'/images/videos/fly-preview.mp4'" type="video/mp4">
                <source :src="subdir+'/images/videos/fly-preview.webm'" type="video/webm">

            </video>

            <div class="media-wraper"
                 v-bind:class="{fix:!flyPreviewActive }"
            >
                <div
                    class="media-section-wrap"
                    v-for="(item, index) in envSlugsProcessed"
                    :key="index"

                >
                    <img
                        v-bind:class="[item.imgStyle]"
                        :ref="item.id+'img'"
                        :id="item.id+'img'"
                        class="media-section image"
                        :src="subdir+'/images/slider/'+item.file+'.jpg'">
                    <video preload="auto"
                           class="media-section video video-right"
                           v-bind:class="[item.id+'video',{toTop:item.videoRightStyle}]"
                           :ref="item.id+'video_right'"
                           :id="item.id+'video_right'"
                           muted
                           v-on:ended="videoCompletedRight(index)"
                    >
                        <source :src="subdir+'/images/slider/'+item.file+'_right.mp4'" type="video/mp4">
                        <source :src="subdir+'/images/slider/webm/'+item.file+'_right.webm'" type="video/webm">
                    </video>
                    <video
                        preload="auto"
                        class="media-section video video-left"
                        v-bind:class="[item.id+'video',{toTop:item.videoLeftStyle}]"
                        :ref="item.id+'video_left'"
                        :id="item.id+'video_left'"
                        muted
                        v-on:ended="videoCompletedLeft(index)"
                    >

                        <source :src="subdir+'/images/slider/'+item.file+'_left.mp4'" type="video/mp4">
                        <source :src="subdir+'/images/slider/webm/'+item.file+'_left.webm'" type="video/webm">

                    </video>
                    <video
                        class="media-section video video-to"
                        v-bind:class="[item.id+'video',{toTop:item.videoToStyle}]"
                        :ref="item.id+'video_to'"
                        :id="item.id+'video_to'"
                        muted
                        v-on:ended="videoCompletedTo(index)">

                        <source :src="subdir+'/images/slider/'+item.file+'_to.mp4'" type="video/mp4">
                        <source :src="subdir+'/images/slider/webm/'+item.file+'_to.webm'" type="video/webm">

                    </video>
                    <!--<video-->
                    <!--class="media-section video video-from"-->
                    <!--v-bind:style="item.videoFromStyle"-->
                    <!--v-bind:class="[item.id+'video']"-->
                    <!--:ref="item.id+'video_from'"-->
                    <!--:id="item.id+'video_from'"-->
                    <!--:src="'/images/slider/'+item.file+'_from.mp4'"-->
                    <!--muted-->
                    <!--v-on:ended="videoCompletedFrom(index)"></video>-->

                </div>

            </div>


            <div class="btn to-left"
                 v-bind:class="{stop:goRight!==null || goLeft!==null || goTo!==null}"
                 @click="to_left"
                 v-if="!flyPreviewActive"
            ><img src="@/assets/images/icons/icon-arrow-left.svg"/> left
            </div>
            <div class="btn to-right"
                 v-bind:class="{stop:goRight!==null || goLeft!==null || goTo!==null}"
                 v-if="!flyPreviewActive"
                 @click="to_right"
            > right <img src="@/assets/images/icons/icon-arrow-right.svg"/>
            </div>
            <div class="btn go-to"
                 v-bind:class="{stop:goRight!==null || goLeft!==null || goTo!==null}"
                 v-if="!flyPreviewActive"
                 @click="go_to"
            > go
            </div>

        </div>

        <frontpage v-show="preloadPage"
                   v-on:toEnvironment="videoCompleted('start')"
                   v-on:setActiveEnv="setActiveEnv"
        />

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    import Frontpage from '@/views/Frontpage.vue'
    // import HeroSection from '@/components/landing/HeroSection.vue'
    // import HeroSection2 from '@/components/landing/HeroSection2.vue'
    // import EnvHomeSection from '@/components/landing/EnvHomeSection.vue'


    import NavEnvLanding from '@/components/NavEnvLanding.vue'

    export default {
        name: 'Landing',
        components: {Frontpage, NavEnvLanding},
        props: ['selectEnvironments', 'activeEnv', 'envListImages'],
        data() {
            return {

                //===
                displayType:'mob',
                typeSol: false,
                switchDisable: true,
                //===


            // showMenuInLanding:false,
                // preloadPage: true,

                isStart: false,
                // flyPreviewHidden: false,
                goRight: null,
                goLeft: null,
                goTo: null,
                nextID: null,
                beforeID: null,

            }
        },

        computed: {
            ...mapGetters({
                subdir: 'environments/subdir',
                showMenuInLanding: 'environments/showMenuInLanding',
                preloadPage: 'environments/preloadPage',
                flyPreviewActive: 'environments/flyPreviewActive',
                environments: 'environments/environments',
                solutions: 'environments/solutions',
                activeEnvSlug: 'environments/activeEnvSlug',
                envSlugs: 'environments/envSlugs',
                goFrom: 'environments/goFrom',
            }),
            envSlugsProcessed() {
                return this.envSlugs.map((item, index) => {
                    let list = {
                        ...item,
                        imgStyle: '',
                        videoRightStyle: '',
                        videoLeftStyle: '',
                        videoToStyle: '',
                        videoFromStyle: '',
                    };

                    if (this.goRight !== null) {
                        list.videoRightStyle = index == this.goRight ? 'toTop' : '';

                    } else if (this.goLeft !== null) {
                        list.videoLeftStyle = index == this.goLeft ? 'toTop' : '';

                    } else if (this.goTo !== null) {

                        list.videoToStyle = index == this.goTo ? 'toTop' : '';

                    }

                    if (index == this.beforeID) {
                        list.imgStyle = 'beforeTop';
                    } else if (index == this.nextID) {
                        list.imgStyle = 'nextTop';
                    } else if (index == this.currentID) {
                        list.imgStyle = 'toTop';
                    } else {
                        list.imgStyle = '';
                    }
                    return list;
                });
            },
            currentID() {
                let obj = this.envSlugs.find((item) => {
                    return item.slug == this.activeEnvSlug;
                });
                let index = this.envSlugs.indexOf(obj);
                return index;
            },

            currentEnvID() {
                let obj = this.environments.find((item) => {
                    return item.slug == this.activeEnvSlug;
                });

                return obj.id;
            },
            elEnv() {
                return this.environments;
            },
            elStrategic() {
                return this.strategic;
            },
            curentEnvironment(){
                let cur ={}
                if (this.activeEnv) {
                    cur = this.getEnvironmentFromID(this.activeEnv);
                }
                return cur;
            }
        },
        watch:{
            activeEnvSlug(){
                let obj = this.environments.find((item) => {
                    return item.slug == this.activeEnvSlug;
                });
                this.$emit('setActiveEnv', obj.id);
            }
        },
        mounted() {

            document.addEventListener("keyup", this.keyupCheker);
            // this.$refs.flyPreview.play();
            this.isStart = true;
        },
        beforeDestroy() {
            document.removeEventListener('keyup', this.keyupCheker);
        },
        methods: {

            getEnvironmentFromID(id) {
                let elEnv = {
                    ...this.environments.find((el) => {
                        return el.id == id;
                    })
                }

                if (Object.prototype.hasOwnProperty.call(elEnv, "solutions")) {
                    elEnv.solutions = elEnv.solutions.map((item) => ({
                        ...item,
                        title: this.solutions[item.id].title
                    }))
                }

                return elEnv;
            },
            changeActiveEnv(slug,env_id) {
                let obj = this.environments.find((item) => {
                    return item.slug == slug;
                });
                this.$emit('setActiveEnv', obj.id);

                // let slug = this.envSlugs[key].slug;
                this.$store.dispatch('environments/setActiveEnvSlug', slug);
                console.log('xxx',env_id)
            },
            goStart() {

                this.$store.dispatch('environments/setFrontPagePreload', false);
                console.log('goStart');
            },
            keyupCheker(event) {
                if ((event.keyCode || event.which) == 37) {// left
                    this.to_left();
                } else if ((event.keyCode || event.which) == 39) { // right
                    this.to_right();
                } else if ((event.keyCode || event.which) == 38) { // up
                    this.go_to();
                }
            },
            videoCompleted(message) {
                console.log('xxx', message)
                this.$store.dispatch('environments/setActiveEnvSlug', 'tech-bar');
                this.$store.dispatch('environments/setFlyPreviewActive', false);
                this.$store.dispatch('environments/setShowMenuInLanding', true);

            },
            videoCompletedRight(id) {
                console.log('videoCompletedRight', id)

                const el = this.envSlugs[this.currentID].id + 'video_right';

                let slug = ''
                if (this.currentID + 1 < this.envSlugs.length) {
                    slug = this.envSlugs[this.currentID + 1].slug;
                } else {
                    slug = this.envSlugs[0].slug;
                }
                this.$store.dispatch('environments/setActiveEnvSlug', slug);
                this.goRight = null;

                this.nextID = null;
                this.beforeID = null;
                setTimeout(() => {
                    this.$refs[el][0].currentTime = 0;
                }, 100)
            },
            videoCompletedLeft() {
                const el = this.envSlugs[this.currentID].id + 'video_left';

                let slug = ''
                if (this.currentID == 0) {
                    slug = this.envSlugs[this.envSlugs.length - 1].slug;
                } else {
                    slug = this.envSlugs[this.currentID - 1].slug;
                }

                this.$store.dispatch('environments/setActiveEnvSlug', slug);
                this.goLeft = null;
                this.nextID = null;
                this.beforeID = null;

                setTimeout(() => {
                    this.$refs[el][0].currentTime = 0;
                }, 100)
            },
            videoCompletedTo() {

                const el = this.envSlugs[this.currentID].id + 'video_to';

                this.$store.dispatch('environments/setBgImage', this.subdir+'/images/environments/' + this.envSlugs[this.currentID].slug + '.jpg');
                let slug = this.envSlugs[this.currentID].slug;
                this.$store.dispatch('environments/setActiveEnvSlug', slug);
                this.goLeft = null;
                this.$emit('setActiveEnv', this.getEnvDBid(this.activeEnvSlug))

                setTimeout(() => {
                    this.$router.push({name: 'Environments'});

                }, 100)
                setTimeout(() => {
                    console.log(el)
                    this.$refs[el][0].currentTime = 0;
                }, 100)


            },

            to_left() {
                if (this.goRight == null && this.goLeft == null && this.goTo == null) {


                    const el = this.envSlugs[this.currentID].id + 'video_left';
                    console.log('elel', el)
                    this.$refs[el][0].play();
                    this.goLeft = this.currentID;

                    this.beforeID = this.currentID;
                    if (this.currentID == 0) {
                        this.nextID = this.envSlugs.length - 1;
                    } else {
                        this.nextID = this.currentID - 1;
                    }
                }
            },
            to_right() {
                if (this.goRight == null && this.goLeft == null && this.goTo == null) {
                    const el = this.envSlugs[this.currentID].id + 'video_right';
                    // console.log('elel', el)
                    this.$refs[el][0].play();
                    this.goRight = this.currentID;
                    this.beforeID = this.currentID;
                    if (this.currentID + 1 < this.envSlugs.length) {
                        this.nextID = this.currentID + 1;
                    } else {
                        this.nextID = 0;
                    }
                }
            },
            go_to() {

                this.$store.dispatch('environments/setShowMenuInLanding', false);
                if (this.goRight == null && this.goLeft == null && this.goTo == null) {
                    // alert(this.envSlugs[this.currentID].slug)
                    const el = this.envSlugs[this.currentID].id + 'video_to';
                    this.$refs[el][0].play();
                    this.goTo = this.currentID;
                }
            },
            setActiveEnv(id) {
                this.$emit('setActiveEnv', id)
                // this.$router.push({name: 'Environments'});
            },


            addEnv(id) {
                this.$emit('addEnv', id)
            },
            removeEnv(id) {
                this.$emit('removeEnv', id)
            },
            getEnvDBid(slug) {
                console.log('slug', slug);
                console.log('this.environments', this.environments);
                let sl = 1;
                // console.log('environments:',this.environments)
                sl = this.environments.find((item) => {
                    return item.slug == slug;
                });
                return sl.id;
            },
        }

    }
</script>
